import { render, staticRenderFns } from "./DropdownContainer.vue?vue&type=template&id=be21a732&"
import script from "./DropdownContainer.vue?vue&type=script&lang=js&"
export * from "./DropdownContainer.vue?vue&type=script&lang=js&"
import style0 from "./DropdownContainer.vue?vue&type=style&index=0&id=be21a732&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports